// Shared app defaults
export const DEFAULT_COUNTRY_CODE = "IN";
